import React, { useState } from 'react';
import { ChevronDown, X, User, Calendar, Clock, Video, Building } from 'lucide-react';
import './ConsultationHeader.scss';

const ConsultationHeader = ({ 
  name, 
  age, 
  gender, 
  consultationDetails = {},
  showDetailsButton = false 
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  return (
    <>
      <header className="consultation-header">
        <div className="header-content">
          <div className="info-section">
            <div className="name-row">
              <h1 className="name">{name || 'Guest'},</h1>
            </div>
            {(age || gender) && (
              <div className="details-row">
                                {/* {age && gender && <span className="separator" hidden={true}>•</span>} */}
                                {age && (
  <span className="detail-item">
    {Number(age)}{Number(age) <= 1 ? " yr" : " yrs"},
  </span>
)}                {gender && <span className="detail-item">{gender}</span>}
              </div>
            )}
          </div>

          {showDetailsButton && (
            <button 
              className="details-button"
              onClick={toggleDropdown}
              aria-label="Toggle consultation details"
            >
              <ChevronDown 
                size={20} 
                className={`chevron-icon ${isDropdownOpen ? 'open' : ''}`}
              />
            </button>
          )}
        </div>
      </header>

      {showDetailsButton && (
        <div className={`dropdown-panel ${isDropdownOpen ? 'open' : ''}`}>
          <div className="dropdown-content">
            <div className="dropdown-header">
              <h3>Consultation Details</h3>
              <button 
                className="close-button"
                onClick={toggleDropdown}
                aria-label="Close details"
              >
                <X size={20} />
              </button>
            </div>
            
            <div className="details-grid">
              {consultationDetails.patientName && (
                <div className="detail-card">
                  <User size={18} className="detail-icon" />
                  <div className="detail-content">
                    <span className="detail-label">Patient</span>
                    <span className="detail-value">{consultationDetails.patientName}</span>
                  </div>
                </div>
              )}

              {consultationDetails.doctorName && (
                <div className="detail-card">
                  <User size={18} className="detail-icon" />
                  <div className="detail-content">
                    <span className="detail-label">Doctor</span>
                    <span className="detail-value">{consultationDetails.doctorName}</span>
                  </div>
                </div>
              )}

              {consultationDetails.date && (
                <div className="detail-card">
                  <Calendar size={18} className="detail-icon" />
                  <div className="detail-content">
                    <span className="detail-label">Date</span>
                    <span className="detail-value">{consultationDetails.date}</span>
                  </div>
                </div>
              )}

              {consultationDetails.time && (
                <div className="detail-card">
                  <Clock size={18} className="detail-icon" />
                  <div className="detail-content">
                    <span className="detail-label">Time</span>
                    <span className="detail-value">{consultationDetails.time}</span>
                  </div>
                </div>
              )}

              {consultationDetails.modeOfConsultation && (
                <div className="detail-card">
                  <Video size={18} className="detail-icon" />
                  <div className="detail-content">
                    <span className="detail-label">Mode</span>
                    <span className="detail-value">{consultationDetails.modeOfConsultation}</span>
                  </div>
                </div>
              )}

              {consultationDetails.branch && (
                <div className="detail-card">
                  <Building size={18} className="detail-icon" />
                  <div className="detail-content">
                    <span className="detail-label">Branch</span>
                    <span className="detail-value">{consultationDetails.branch}</span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ConsultationHeader;